export const SCHEMA = `
CREATE TABLE IF NOT EXISTS facultades (
    id TEXT PRIMARY KEY,
    nombre TEXT NOT NULL,
    sigla TEXT NOT NULL,
    disponible INTEGER NOT NULL,
    escala_calificacion_id TEXT,
    terminologia TEXT NOT NULL,
    design_tokens_ref TEXT
);

CREATE TABLE IF NOT EXISTS carreras (
    id TEXT PRIMARY KEY,
    facultad_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    tipo TEXT NOT NULL,
    creditos_totales INTEGER NOT NULL,
    duracion_semestres INTEGER NOT NULL,
    locacion TEXT NOT NULL,
    malla_precargada INTEGER NOT NULL,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id)
);

CREATE TABLE IF NOT EXISTS planes_estudio (
    id TEXT PRIMARY KEY,
    nombre TEXT NOT NULL,
    facultad TEXT NOT NULL,
    duracion_semestres INTEGER NOT NULL
);

CREATE TABLE IF NOT EXISTS escalas_calificacion (
    id TEXT PRIMARY KEY,
    facultad TEXT NOT NULL,
    nombre TEXT NOT NULL,
    niveles TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS modulos (
    id TEXT PRIMARY KEY,
    facultad_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    creditos_minimos INTEGER NOT NULL DEFAULT 0,
    color_hex TEXT,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id)
);

CREATE TABLE IF NOT EXISTS ciclos (
    id TEXT PRIMARY KEY,
    facultad_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    creditos_minimos INTEGER NOT NULL DEFAULT 0,
    orden INTEGER NOT NULL DEFAULT 1,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id)
);

CREATE TABLE IF NOT EXISTS acreditaciones_libres (
    id TEXT PRIMARY KEY,
    usuario_id TEXT,
    facultad_id TEXT NOT NULL,
    modulo_id TEXT,
    nombre_actividad TEXT NOT NULL,
    creditos INTEGER NOT NULL,
    fecha_acreditacion TEXT NOT NULL,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id),
    FOREIGN KEY(modulo_id) REFERENCES modulos(id)
);

CREATE TABLE IF NOT EXISTS asignaturas (
    id TEXT PRIMARY KEY,
    plan_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    codigo TEXT,
    semestre_sugerido INTEGER,
    creditos INTEGER NOT NULL,
    departamento TEXT,
    facultad_origen TEXT,
    estado TEXT NOT NULL CHECK (estado IN ('no_iniciada', 'en_curso', 'cursando', 'a_examen', 'aprobada', 'abandonada', 'no_cursada', 'reprobada')),
    requisitos TEXT,
    periodo_cursado TEXT,
    fecha_inicio TEXT,
    fecha_fin TEXT,
    fecha_aprobacion TEXT,
    nota_final REAL,
    porcentaje_logro REAL,
    concepto_final TEXT,
    posicion_x REAL,
    posicion_y REAL,
    eva_url TEXT,
    sala9_url TEXT,
    ano_cursado INTEGER,
    en_papelera INTEGER DEFAULT 0,
    eliminado_en TEXT,
    es_opcional INTEGER DEFAULT 0,
    dictado TEXT,
    previas_sugeridas TEXT,
    calificacion_oficial INTEGER,
    aplazos TEXT,
    modulo_id TEXT,
    ciclo_id TEXT,
    FOREIGN KEY(plan_id) REFERENCES planes_estudio(id),
    FOREIGN KEY(modulo_id) REFERENCES modulos(id),
    FOREIGN KEY(ciclo_id) REFERENCES ciclos(id)
);

CREATE TABLE IF NOT EXISTS evaluaciones (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    tipo TEXT NOT NULL,
    nombre TEXT NOT NULL,
    fecha TEXT NOT NULL,
    porcentaje_logro REAL,
    concepto TEXT,
    nota REAL,
    escala TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);

CREATE TABLE IF NOT EXISTS materiales (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    tipo TEXT NOT NULL,
    ruta_relativa TEXT NOT NULL,
    nombre TEXT NOT NULL,
    tags TEXT,
    fecha_agregado TEXT NOT NULL,
    url_r2 TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);

CREATE TABLE IF NOT EXISTS eventos_calendario (
    id TEXT PRIMARY KEY,
    tipo TEXT NOT NULL,
    asignatura_id TEXT,
    fecha TEXT NOT NULL,
    descripcion TEXT NOT NULL,
    hora TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);

CREATE TABLE IF NOT EXISTS carpetas_notas (
    id TEXT PRIMARY KEY,
    nombre TEXT NOT NULL,
    color TEXT,
    padre_id TEXT,
    fecha_creacion TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS notas_generales (
    id TEXT PRIMARY KEY,
    titulo TEXT NOT NULL,
    contenido TEXT NOT NULL,
    carpeta_id TEXT,
    asignatura_id TEXT,
    evento_id TEXT,
    tags TEXT,
    en_papelera INTEGER DEFAULT 0,
    fecha_creacion TEXT NOT NULL,
    fecha_modificacion TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS horarios_clases (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    dia TEXT NOT NULL CHECK (dia IN ('lunes', 'martes', 'miercoles', 'jueves', 'viernes')),
    hora_inicio TEXT NOT NULL,
    hora_fin TEXT NOT NULL,
    grupo TEXT,
    salon TEXT,
    docente TEXT,
    observaciones TEXT,
    periodo TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id)
);

CREATE TABLE IF NOT EXISTS historial_academico (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    fecha TEXT NOT NULL DEFAULT '',
    instancia TEXT NOT NULL CHECK (instancia IN ('curso_reglamentado', 'examen_libre')),
    resultado TEXT NOT NULL CHECK (resultado IN ('aprobado', 'reprobado')),
    calificacion INTEGER,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);
`;
